module.exports = __webpack_public_path__ + "static/media/demisec.c4899d68.JPG";